import useAppSelector from '@/hooks/useAppSelector'
import { useIsMinWidthSm } from '@/hooks/useIsMinWidthSm'
import { isOffice } from '@/lib/helpers/officeHelpers'
import { ROUTES } from '@/lib/routes'
import {
  selectIsAuthenticatedClient,
  selectIsCompanyUser,
  selectIsGroupUser,
  selectIsIcaewUser,
  selectIsNetworkUser,
} from '@/redux/slices/session'

export function useHomeRoute() {
  const isAuthenticatedClient = useAppSelector(selectIsAuthenticatedClient)
  const isGroupUser = useAppSelector(selectIsGroupUser)
  const isNetworkUser = useAppSelector(selectIsNetworkUser)
  const isCompanyUser = useAppSelector(selectIsCompanyUser)
  const isIcaewUser = useAppSelector(selectIsIcaewUser)
  const isSmWidth = !useIsMinWidthSm()

  if (isOffice()) {
    return ROUTES.officeTaskPane()
  }

  if (isAuthenticatedClient) {
    return ROUTES.compassDashboard()
  }

  if (isIcaewUser) {
    return ROUTES.icaewOverview()
  }

  if (isGroupUser) {
    return ROUTES.groupOverview()
  }

  if (isNetworkUser) {
    return ROUTES.networkOverview()
  }

  if (isCompanyUser) {
    if (isSmWidth) {
      return ROUTES.mobileLanding()
    }

    return ROUTES.companyDashboard()
  }

  // TODO:
  // This assumes that users can only register as company users.
  // Will need to account for client users registering too.
  return ROUTES.redirectNewUser()
}
